import { TableCellWidth } from '@app/src/components/Table'
import TagsCell from '@app/src/components/Table/Cells/TagsCell'
import type { Question } from '@app/src/types/resourceExplorer'
import { TableCell } from '@mui/material'
import React from 'react'
import { getQuestionQuestionnaires } from './questionQuestionnaires'

export const QUESTIONNAIRES_COLUMN_WIDTH = TableCellWidth.LARGE

interface QuestionnairesCellProps {
  question: Question
}

const QuestionnairesCell: React.FC<QuestionnairesCellProps> = ({ question }) => {
  const titles = getQuestionQuestionnaires(question).map(questionnaire => questionnaire.title)

  return (
    <TableCell sx={{ width: QUESTIONNAIRES_COLUMN_WIDTH, maxWidth: QUESTIONNAIRES_COLUMN_WIDTH }}>
      <TagsCell tags={titles} amountOfTagsShow={3} disableCell />
    </TableCell>
  )
}

export default QuestionnairesCell
